import { Card, Container, Row } from "react-bootstrap"
import { AudienceByNetwork } from "./charts/AudienceByNetwork"
import AudienceBreakdown from "./charts/AudienceBreakdown"

/*
    Audience tab (MPN-1530 §5).

    Opens with the per-audience sizing and match table, which is the question this tab
    exists to answer. AudienceHud is retired: it showed three tiles that were the same
    number three times over (§5.2), which is the bug this ticket fixes.
*/

const Audience = ({ data }: { data: any }) => {
  return (
    <Container className="d-flex flex-column gap-3 mb-3">
      <Row>
        <Card className="custom-card overflow-hidden mb-0 border border-2">
          <Card.Header className="justify-content-between">
            <Card.Title>Audience Sizing</Card.Title>
          </Card.Header>
          <Card.Body>
            <AudienceBreakdown data={data} />
          </Card.Body>
        </Card>
      </Row>

      {/*
          "Audience By Network" removed (MPN-1548). It broke the same matched counts down
          by network as a bar chart, which the Matched By Network table inside Audience
          Sizing already lists with the match rate beside it. Two readings of one number,
          and the table is the one that answers "is this network matching well".

          Audience By Day below is deliberately kept: the ticket names one chart, and this
          is the only view of matched counts moving over time.
      */}
      <Row>
        <Card className="custom-card mb-0 border border-2">
          <Card.Header>
            <Card.Title>Audience By Day</Card.Title>
          </Card.Header>
          <Card.Body>
            <AudienceByNetwork series={data["audience-by-network"]} />
          </Card.Body>
        </Card>
      </Row>
    </Container>
  )
}

export default Audience
